import React, {
  Fragment
} from 'react';
import PropTypes from 'prop-types';
class UserRoleCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this.state ={
      checked: this.props.enabled,
      updated: false
    };
  }
  update = (checkboxName, event) => {
    this.props.updateResult(checkboxName, event)
    this.setState({
      checked: event,
      updated: true
    });
    this.timer = setTimeout(function(){
      this.setState({
        updated:false
      });
    }.bind(this),2500);
  }
  componentWillUnmount() {
    if (this.timer) clearInterval(this.timer)
  }
  render() {
    const { description, checkboxName, enabled, updateStatus } = this.props;
    const { updated } = this.state;
    return (
      <div>
        <div className="row">
          <div className="col-6">
            <p className="role-desc">{description}</p>
          </div>
          <div className="col-6">
            <div className="switch-container">
              <label className="switch">
                <input className="toggler-live" type="checkbox" name={checkboxName} defaultChecked={enabled} onChange={() => this.update(checkboxName, event.target.checked)} />
                <span className="check-switch"></span>
              </label>
              {updated && updateStatus &&
                <div className="status">Updated!</div>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default UserRoleCheckbox
